import React from "react";
import { TestID } from "../../shared/testids/testids";
import { CheckboxProps, Radio, RadioGroupProps, Space, SpaceProps } from "antd";
import "./CORERadioButton.less";
import { Merge } from "../../shared/TypeScriptHelpers";

export const radioButtonGroup = {
  sm: "radio-btn-space-sm",
  md: "radio-btn-space-md",
  lg: "radio-btn-space-lg",
  xl: "radio-btn-space-xl",
};
export type spaceSize = keyof typeof radioButtonGroup;
export type RadioButtonGroupProps = Merge<
  RadioGroupProps,
  {
    testID: TestID;
    radioBtnValues?: RadioBtnValueType[];
    tabIndex?: number;
    widthSize?: "default" | "full" | "small";
    contentSpace?: spaceSize;
    direction?: SpaceProps["direction"];
  }
>;

type RadioButtonType = Merge<
  CheckboxProps,
  {
    testID: TestID;
    name?: React.ReactNode;
  }
>;

export type RadioBtnValueType = Merge<
  CheckboxProps,
  {
    name: React.ReactNode;
    value: string | number | boolean;
    testID: TestID;
  }
>;

export const CORERadioButtonBasic: React.FC<RadioButtonType> = ({
  testID,
  name,
  ...props
}) => {
  return (
    <Radio data-testid={testID} {...props}>
      {name}
    </Radio>
  );
};

export const CORERadiobuttonGroup: React.FC<RadioButtonGroupProps> = ({
  radioBtnValues,
  testID,
  optionType,
  tabIndex,
  direction = "horizontal",
  widthSize = "default",
  contentSpace = "md",
  children,
  ...otherProps
}) => {
  const spaceClassName = radioButtonGroup[`${contentSpace}`];
  return (
    <div data-testid={testID} className={"radio-button"}>
      <Radio.Group {...otherProps} className={`input-radio-${widthSize}-size`}>
        {children ??
          (optionType === "button" ? (
            (radioBtnValues ?? []).map(({ name, value, ...props }) => {
              return (
                <Radio.Button
                  key={`radio-${value}`}
                  className={spaceClassName}
                  value={value}
                  tabIndex={tabIndex}
                  {...props}
                >
                  {name}
                </Radio.Button>
              );
            })
          ) : (
            <Space direction={direction}>
              {(radioBtnValues ?? []).map(({ name, value, ...props }) => {
                return (
                  <CORERadioButtonBasic
                    key={`radio-${value}`}
                    name={name}
                    value={value}
                    tabIndex={tabIndex}
                    {...props}
                  />
                );
              })}
            </Space>
          ))}
      </Radio.Group>
    </div>
  );
};
